<template>
    <Attr :widget_id="widget_id" :attr_id="attr_id">
        <label class="label-sheet" v-if="attr.title && !attr.hideTitle" :for="attr.html_id">{{ attr.title }}</label>
        <div class="attr-codemirror"
            v-wjTooltip="attr.tooltip"
            v-wjContextMenu="'ContextWidgetMenuId'"
        >
            <div class="grid-top-line strmulti-fold-buttons" ref="attr_top_line" v-if="!attr?.hideCommandPanel">
                <div class="commandPanel-area" ref="commandPanelArea"
                    :style="commandPanelAreaWidth != null ? { flex: '0 1 ' + commandPanelAreaWidth + 'px' } : (!commandPanel.length && !commandPanelOverflow.length ? { flex: '0 0 0', minWidth: '0', overflow: 'hidden' } : {})"
                >
                    <div class="commandPanel-menu" v-if="commandPanel.length && commandPanelMaxVisible !== 0" ref="commandPanelMenu"
                        :style="commandPanelMenuWidth != null ? { flex: '0 0 ' + commandPanelMenuWidth + 'px' } : {}"
                    >
                        <span v-for="(attrM, index) in commandPanel"
                            :key="attrM.html_id"
                            class="cp-item-wrap"
                            v-show="index < commandPanelMaxVisible"
                        >
                            <component
                                :widget_id="widget_id"
                                :is="attrM.component"
                                :attr_id="attrM.id"
                                :initialAttr="attrM"
                            />
                        </span>
                    </div>
                    <div class="widget_menu commandPanel-overflow-btn" v-if="commandPanelOverflow.length">
                        <wj-menu
                            class="commandPanel-overflow-menu"
                            :header="''"
                            :displayMemberPath="'titleAction'"
                            :subItemsPath="'attrs'"
                            :showDropDownButton="false"
                            :openOnHover="true"
                            :isAnimated="false"
                            :itemsSource="commandPanelOverflow"
                            :itemClicked="menuNodeClicked"
                            :formatItem="store.formatMenuItem"
                        >
                            <i class="pi pi-ellipsis-v"></i>
                        </wj-menu>
                    </div>
                </div>
                <div class="grid-chips" v-if="!attr?.hideCHIPS && !initialAttr">
                    <AttrChips ref="chips" :widget_id="widget_id" :attr_id="attr_id" :modelValue="chips_list" @update:modelValue="onChipsUpdate" @chip-search-nav="onChipSearchNav" :mode="'Legacy'" />
                </div>
                <!-- IE 2026 09 28 / ODOO-342342 (заказ Игоря: «"меню" — прижато вправо и форма меню как у ≡ таблицы»): ≡ поля — панель функций MenuPanel (те же пункты actionMenu:
                     Command panel и Fold: 0…∞ — группой «Fold»; поиск, избранное) у правого края строки (и без чипсов — поле в ячейке, hideCHIPS);
                     прежний wj-menu — флаг fe.ux.menuPanelEverywhere выключен / мобильный профиль (utils/menuPanelHost.js) -->
                <div class="widget_menu mr-2" :class="{ 'menu-push-right': menuPanelHost_on() }">
                    <MenuPanel v-if="actionMenu.length && menuPanelHost_on()" :items="actionMenu" align="right" :caret="false" btnClass="widget-menu-btn field-menu-btn"
                        :title="t('Field menu')" titleIcon="pi pi-bars" :subtitle="menuPanelSubtitle()" :openDelay="200" :runsTitle="t('Fold')" search :searchPlaceholder="t('Search commands…')"
                        :favKey="menuFavKind()" :favOf="menuFavOf" :epoch="store._favEpoch" :favTitle="t('Favourite command')" help="field" :btnShort="t('Field menu')"
                        @pick="menuPanelPick" @fav="menuFav">
                        <template #trigger><i class="pi pi-bars pi-bold"></i></template>
                    </MenuPanel>
                    <wj-menu id="actionMenuId" :displayMemberPath="'titleAction'" :subItemsPath="'attrs'" :showDropDownButton="false"
                        v-else-if="actionMenu.length"
                        :openOnHover="true" :isAnimated="false" :itemsSource="actionMenu" :itemClicked="menuNodeClicked" :formatItem="store.formatMenuItem"
                    >
                        <i class="pi pi-bars pi-bold"></i>
                    </wj-menu>
                </div>
            </div>
            <Codemirror
                :id="attr.html_id"
                v-model:value="content_str"
                v-visible="handleVisibility"
                :options="cmOptions"
                @change="attr_set"
                @ready="editorReady"
                @keydown="handleKeydown"
            />
        </div>
        <!-- IE 2026 10 06 / ODOO-341407 (заказ Игоря п.2, DESIGN §3.3): опция виджета «Show translation fields» — под отдельным translate-полем (вкладка «Інфо»:
             Comment) поля переводов «<поле> (uk)», «<поле> (ru)»; под uk / ru первым — «(en)», английская база, только чтение (решение В2). Путь перевода
             выводится из binding поля (meta.comment → meta.comment_uk; utils/i18nFields.js companionRowsFor), правка — store.attr_set: запись помечается изменённой -->
        <div class="i18n-companions" ref="i18nCompanions" v-if="i18nCompanions.length">
            <div class="i18n-companion-row" v-for="V in i18nCompanions" :key="V.binding" :class="{ 'i18n-auto': V._i18nOf?.auto, 'i18n-en': V._i18nOf?.en }">
                <label class="label-sheet" :for="i18nCompanion_id(V)">{{ V.title }}</label>
                <textarea class="i18n-companion" :id="i18nCompanion_id(V)" rows="3" :lang="V._i18nOf?.lang" :title="V.tooltip || null"
                    :value="i18nCompanion_value(V)" :readonly="V.isReadOnly"
                    @input="i18nCompanion_input(V, $event)" @change="i18nCompanion_changed(V)"></textarea>
            </div>
        </div>
    </Attr>
</template>

<script>
import { useMainStore } from '@/stores/mainStore'

import Codemirror from "codemirror-editor-vue3";
import "codemirror/mode/javascript/javascript.js";

import "codemirror/mode/python/python.js";
import "codemirror/mode/sql/sql.js";
import "codemirror/addon/search/searchcursor.js"; // задача 14 ч.1: getSearchCursor для навигации по совпадениям

import "codemirror/theme/dracula.css";
import "codemirror/addon/fold/foldcode";
import "codemirror/addon/fold/foldgutter";

import "codemirror/addon/fold/brace-fold";   // для JS/{} – можно оставить
import "codemirror/addon/fold/indent-fold";  // ← ОБЯЗАТЕЛЬНО для Python
import "codemirror/addon/fold/comment-fold"; // ← регионы в комментариях (опционально)

// HINT (обязательно)
import "codemirror/addon/hint/show-hint.js";
import "codemirror/addon/hint/show-hint.css";

// простая подсказка по словам из буфера
import "codemirror/addon/hint/anyword-hint.js";

import "codemirror/addon/fold/foldgutter.css";
import "codemirror/theme/neo.css";
import { menuPanelHostMixin } from '@/utils/menuPanelHost'   // IE 2026 09 28 / ODOO-342342: ≡ поля — MenuPanel (как ≡ таблицы), прижат вправо
import { companionRowsFor as i18n_companionRowsFor, formEditTarget as i18n_formEditTarget, bindingsOf as i18n_bindingsOf } from '@/utils/i18nFields'   // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.2, DESIGN §3.3): поля переводов под полем, правка под uk / ru — только перевод

export default {
    mixins: [menuPanelHostMixin],   // IE 2026 09 28 / ODOO-342342
    props: {
        attr_id: String,
        widget_id: [String, Number],
        initialAttr: {
            type: Object,
            default: null,
        },
        parentAttr: { // объект вкладки от рендерящего AttrTab/AttrTabRow (tabs_noId)
            type: Object,
            default: null,
        },
        modelValue: { type: String, default: "" }, // ✅ v-model без аргумента
    },
    emits: ['keydown', 'update:modelValue'],
    data: () => ({
        WIDGET: {},
        content_str: '',
        count_empty_tab: 0,
        refresh_editor: true,
        commandPanel: [],
        actionMenu: [],
        ind_commandPanel: 0,
        chips_list: [],
        commandPanelMaxVisible: Infinity,
        commandPanelAreaWidth: null,
        commandPanelMenuWidth: null,
        i18nEpoch: 0,   // IE 2026 10 06 / ODOO-341407: this.attr не реактивен (ставит widget_attr_set) — смена узла поля пересчитывает поля переводов (computed i18nCompanions)
        cmOptions: {
            mode: "python", // Language mode
            theme: "neo", // Theme
            lineNumbers: true, // Show line number
            smartIndent: true, // Smart indent
            indentUnit: 4, // The smart indent unit is 2 spaces in length
            foldGutter: true, // Code folding
            styleActiveLine: true, // Display the style of the selected row
            // fontsize: "small",
        },
    }),
    setup() {
        const store = useMainStore();
        return { store }
    },
    created() {
        // console.log(`created ${this.attr_id}`)
        this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        this.content_Changed()
        this.set_commandPanel()
    },
    mounted() {
        this.WIDGET.attrsResize = this.WIDGET.attrsResize || []
        this.WIDGET.attrsResize.push(this.attrResize)
        this.$nextTick(() => {
            const container = this.$refs.commandPanelMenu
            const topLine = this.$refs.attr_top_line
            if (container && topLine && !this.commandPanelResizeObserver) {
                this.commandPanelResizeObserver = new ResizeObserver(() => this.updateCommandPanelOverflow())
                this.commandPanelResizeObserver.observe(topLine)
                const chipsEl = topLine.querySelector('.grid-chips')
                if (chipsEl) this.commandPanelResizeObserver.observe(chipsEl)
            }
            this.updateCommandPanelOverflow()
        })
    },
    beforeUnmount() {
        this.commandPanelResizeObserver?.disconnect()
        if (this._cpRafId) cancelAnimationFrame(this._cpRafId)
        if (this.WIDGET.attrsResize) {
            const idx = this.WIDGET.attrsResize.indexOf(this.attrResize)
            if (idx !== -1) this.WIDGET.attrsResize.splice(idx, 1)
        }
        this.store.attr_deregister(this)
    },
    methods: {
        content_Changed(command) {
            if (this.initialAttr) {
                this.attr = this.initialAttr
                this.WIDGET.attrs_vueObj[this.attr_id] = this
                if (this.attr.dropdown) {
                    this.content_str = this.modelValue
                }
            } else {
                this.store.widget_attr_set(this)
            }

            this.need_content_Changed_afterTimeout = true
            if (!this.isVisible) {
                return
            }
            if (this.content_Changed_timeout) { clearTimeout(this.content_Changed_timeout) }
            this.content_Changed_timeout = setTimeout(() => {
                this.content_Changed_afterTimeout(command)
            }, this.isVisible ? 1 : 700)
        },
        content_Changed_afterTimeout(command) {
            if (!this.attr) {
                return
            }
            this.need_content_Changed_afterTimeout = false
            if (!this.attr.dropdown) {
                this.store.widget_attr_set(this)
            }
            if (this._i18nAttr !== this.attr) { this._i18nAttr = this.attr; this.i18nEpoch++ }   // IE 2026 10 06 / ODOO-341407: узел поля сменился (пересборка вида) — поля переводов по новому узлу
            if (!this._tabFeatures_initialized && this.parent_attr && !this.initialAttr) {
                this._tabFeatures_initialized = true
                if (this.parent_attr?.attr_type === 'AttrTab' && !this.parent_attr?.['hide-countItems']) {
                    this.attr['can-set_AttrTabPanel_countItems'] = true
                }
                this.attr_nonEmptyWidget = this.store.get_field0(this.WIDGET.groupMenu?.commandPanel, 'non-empty-widget', 'name')
                if (!this.attr.showEmpty && this.attr_nonEmptyWidget) {
                    this.WIDGET.applys_CHIPS[this.attr.id] = this
                }
            }
            if (this.attr.cmOptions) {
                this.cmOptions = this.attr.cmOptions
            }
            this.cmOptions.hintOptions = {
                // hint: CodeMirror.hint.anyword, // источник слов (буфер редактора)
                hint: this.pythonHint,
                completeSingle: false,         // не подставлять единственный вариант автоматически
            }
        
            if (!this.attr.dropdown) {
                // null/undefined нормализуем в '' — иначе для пустого поля сравнение
                // всегда неравно ('' !== null) и редактор сбрасывается на каждом reload
                const new_content_str = this.store.attr_get(this.WIDGET, this.attr) || ''
                if (this.content_str !== new_content_str) {
                    this.content_str = new_content_str
                    this.refresh_editor = true
                }
            }
            if (this.editor && this.refresh_editor) {
                this.refresh_editor = false
                this.editor.setValue(String(this.content_str || ''))
                this.editor.refresh()

                // fold all lines to the first level
                if (command?.fold) {
                    const editor = this.editor,
                        vueObj = this

                    // setTimeout(() => {
                        this.editor.operation(() => {
                            for (let i = 0; i < this.editor.lineCount(); i++) {
                                // this.editor.foldCode(CodeMirror.Pos(i, 0));
                                this.editor.foldCode(CodeMirror.Pos(i, 0), null, "fold")
                                // if (vueObj.isLineFolded(this.editor, i)) {
                                //     console.log(`Line ${i} is folded`);
                                // }
                            }
                        })
                    // }, 5)
                }
            }
            this.check_attrTab()
            this.set_AttrTabPanel_countItems()
            this.apply_CHIPS()
        },
        set_commandPanel() {
            const commandPanel = []
            const eval_params = { attr: this.attr }
            const source_name = this.attr_id

            let need_separator = commandPanel.length
            if (this.attr?.groupMenu?.commandPanel) {
                this.attr.groupMenu.commandPanel.forEach(attrButton => {
                    const v_if = attrButton['v-if']
                    if (!attrButton.autoGeneratedButton) {
                        const visible_ = this.store.eval_value(this.WIDGET, v_if, eval_params)
                        if (attrButton.visible != visible_) {
                            attrButton.visible = visible_
                        }
                        if (need_separator) {
                            commandPanel.push({ autoGeneratedButton: true })
                            need_separator = false
                        }
                        commandPanel.push(attrButton)
                    }
                })
            }

            commandPanel.push({ autoGeneratedButton: true })
            // IE 2026 09 23 / ODOO-341407: i18n: подписи кнопок свёртки
            for (const fold_deep of [0, 1, 2, Infinity]) {
                const label = fold_deep === Infinity ? '∞' : String(fold_deep)
                commandPanel.push({
                    'attr_type': 'AttrButton', source_name, 'binding': this.attr?.binding,
                    'title': fold_deep === 0 ? this.t('Fold: {n}', { n: label }) : label,
                    'command': 'onFold_deep__Click', 'params': { fold_deep },
                    'cssClass': 'pi p-button-white p-2', 'showCommandTitle': true,
                })
            }

            this.store.prepare_attrs(commandPanel, (this.attr?.html_id || this.attr?.id || 'strmulti') + (++this.ind_commandPanel))

            this.actionMenu = this.store.actionMenu_from_commandPanel(commandPanel)
            const actions = [
                { 'attr_type':'AttrButton', source_name:this.attr?.name, 'binding':this.attr?.binding, 'title': this.t('Fold: {n}', { n: 0 }), 'command': 'onFold_deep__Click', 'params':{'fold_deep':0} },
                { 'attr_type':'AttrButton', source_name:this.attr?.name, 'binding':this.attr?.binding, 'title': this.t('Fold: {n}', { n: 1 }), 'command': 'onFold_deep__Click', 'params':{'fold_deep':1} },
                { 'attr_type':'AttrButton', source_name:this.attr?.name, 'binding':this.attr?.binding, 'title': this.t('Fold: {n}', { n: 2 }), 'command': 'onFold_deep__Click', 'params':{'fold_deep':2} },
                { 'attr_type':'AttrButton', source_name:this.attr?.name, 'binding':this.attr?.binding, 'title': this.t('Fold: {n}', { n: 3 }), 'command': 'onFold_deep__Click', 'params':{'fold_deep':3} },
                { 'attr_type':'AttrButton', source_name:this.attr?.name, 'binding':this.attr?.binding, 'title': this.t('Fold: {n}', { n: 4 }), 'command': 'onFold_deep__Click', 'params':{'fold_deep':4} },
                { 'attr_type':'AttrButton', source_name:this.attr?.name, 'binding':this.attr?.binding, 'title': this.t('Fold: {n}', { n: 5 }), 'command': 'onFold_deep__Click', 'params':{'fold_deep':5} },
                { 'attr_type':'AttrButton', source_name:this.attr?.name, 'binding':this.attr?.binding, 'title': this.t('Fold: {n}', { n: 6 }), 'command': 'onFold_deep__Click', 'params':{'fold_deep':6} },
                { 'attr_type':'AttrButton', source_name:this.attr?.name, 'binding':this.attr?.binding, 'title': this.t('Fold: {n}', { n: 7 }), 'command': 'onFold_deep__Click', 'params':{'fold_deep':7} },
                { 'attr_type':'AttrButton', source_name:this.attr?.name, 'binding':this.attr?.binding, 'title': this.t('Fold: {n}', { n: '∞' }), 'command': 'onFold_deep__Click', 'params':{'fold_deep': Infinity} },
            ]
            for (const action of actions) {
                this.actionMenu.push(this.store.prepare_actionMenu(action))
            }
            this.commandPanel = commandPanel

            this._cpItemWidths = null
            this.commandPanelMaxVisible = Infinity
            this.commandPanelAreaWidth = null
            this.commandPanelMenuWidth = null
            this.$nextTick(() => {
                const container = this.$refs.commandPanelMenu
                const topLine = this.$refs.attr_top_line
                if (!container || !topLine) return
                if (!this.commandPanelResizeObserver) {
                    this.commandPanelResizeObserver = new ResizeObserver(() => this.updateCommandPanelOverflow())
                }
                this.commandPanelResizeObserver.observe(topLine)
                const chipsEl = topLine.querySelector('.grid-chips')
                if (chipsEl) this.commandPanelResizeObserver.observe(chipsEl)
                this.updateCommandPanelOverflow()
            })
        },
        updateCommandPanelOverflow() {
            if (this._cpRafId) cancelAnimationFrame(this._cpRafId)
            this._cpRafId = requestAnimationFrame(() => {
                this._cpRafId = null
                const cpArea = this.$refs.commandPanelArea
                const topLine = this.$refs.attr_top_line
                if (!cpArea || !topLine) return
                if (topLine.clientWidth <= 10) return
                let itemWidths = this._cpItemWidths
                if (!itemWidths?.length || itemWidths.every(w => w === 0)) {
                    const container = this.$refs.commandPanelMenu
                    itemWidths = container ? Array.from(container.children).map(el => el.offsetWidth) : []
                    if (!itemWidths.length || itemWidths.every(w => w === 0)) return
                    this._cpItemWidths = itemWidths
                }
                const chipsEl = topLine.querySelector('.grid-chips')
                let chipsDesiredWidth = 130
                if (chipsEl) {
                    const inputContainer = chipsEl.querySelector('.input-container')
                    if (inputContainer) {
                        const children = Array.from(inputContainer.children)
                        const sumW = children.reduce((s, el) => s + el.offsetWidth, 0)
                        chipsDesiredWidth = Math.max(sumW + Math.max(children.length - 1, 0) * 4 + 8, 130)
                    }
                }
                const chipsCurrentWidth = chipsEl?.clientWidth ?? 0
                const available = Math.max(cpArea.clientWidth + chipsCurrentWidth - chipsDesiredWidth, 0)
                let total = 0
                let maxVisible = itemWidths.length
                for (let i = 0; i < itemWidths.length; i++) {
                    total += itemWidths[i]
                    if (total > available) { maxVisible = i; break }
                }
                let overflowBtnWidth = 0
                if (maxVisible < itemWidths.length) {
                    const overflowBtnEl = cpArea.querySelector('.commandPanel-overflow-btn')
                    overflowBtnWidth = overflowBtnEl ? overflowBtnEl.offsetWidth : 28
                    const availableForItems = Math.max(available - overflowBtnWidth, 0)
                    total = 0
                    maxVisible = itemWidths.length
                    for (let i = 0; i < itemWidths.length; i++) {
                        total += itemWidths[i]
                        if (total > availableForItems) { maxVisible = i; break }
                    }
                }
                if (this.commandPanelMaxVisible !== maxVisible) this.commandPanelMaxVisible = maxVisible
                let visibleItemsWidth = itemWidths.slice(0, maxVisible).reduce((a, b) => a + b, 0)
                let visibleWidth = visibleItemsWidth + overflowBtnWidth
                if (!this.commandPanelOverflow.length) { visibleItemsWidth += 10; visibleWidth += 10 }
                if (this.commandPanelMenuWidth !== visibleItemsWidth) this.commandPanelMenuWidth = visibleItemsWidth
                if (this.commandPanelAreaWidth !== visibleWidth) this.commandPanelAreaWidth = visibleWidth
            })
        },
        menuNodeClicked(menu) {
            this.menuAction(menu.itemsSource[menu.selectedIndex])   // IE 2026 09 28 / ODOO-342342: выбор пункта wj-menu и MenuPanel (menuPanelPick) — одно действие
        },
        menuAction(action) {   // IE 2026 09 28 / ODOO-342342: прежнее тело menuNodeClicked (из меню выполняется только Fold — как было)
            if (action?.command === 'onFold_deep__Click') {
                const level = action.params?.fold_deep
                if (level === Infinity) {
                    this.unfoldAll()
                } else {
                    this.foldToLevel(level)
                }
            }
        },
        unfoldAll() {
            if (!this.editor) return
            const cm = this.editor
            cm.operation(() => {
                for (let i = 0; i < cm.lineCount(); i++) {
                    cm.foldCode(CodeMirror.Pos(i, 0), null, "unfold")
                }
            })
        },
        foldToLevel(maxLevel) {
            if (!this.editor) return
            const cm = this.editor
            const rangeFinder = cm.getOption('foldOptions')?.rangeFinder || CodeMirror.fold.auto

            cm.operation(() => {
                // unfold all first
                for (let i = 0; i < cm.lineCount(); i++) {
                    cm.foldCode(CodeMirror.Pos(i, 0), null, "unfold")
                }

                // build fold ranges with nesting depth
                const foldRanges = []
                for (let i = 0; i < cm.lineCount(); i++) {
                    const range = rangeFinder(cm, CodeMirror.Pos(i, 0))
                    if (range) {
                        foldRanges.push({ line: i, from: range.from, to: range.to })
                    }
                }

                // compute nesting depth for each foldable line
                for (const r of foldRanges) {
                    r.depth = 0
                    for (const parent of foldRanges) {
                        if (parent === r) continue
                        if (parent.from.line < r.from.line && parent.to.line >= r.to.line) {
                            r.depth++
                        }
                    }
                }

                // fold deepest first, fold ranges with depth >= maxLevel
                foldRanges.sort((a, b) => b.depth - a.depth)
                for (const r of foldRanges) {
                    if (r.depth >= maxLevel) {
                        const marks = cm.findMarksAt(CodeMirror.Pos(r.line, 0))
                        if (marks.some(m => m.collapsed)) continue
                        cm.foldCode(CodeMirror.Pos(r.line, 0), null, "fold")
                    }
                }
            })
        },
        pythonHint(cm) {
            const PY_KEYWORDS = [
                "def","class","import","from","as","return","yield","if","elif","else","try","except",
                "finally","for","while","break","continue","pass","with","lambda","nonlocal","global",
                "assert","raise","del","in","is","and","or","not","match","case"
            ];

            const PY_BUILTINS = [
                "print","len","range","enumerate","map","filter","zip","sum","min","max","sorted","reversed",
                "dict","list","set","tuple","str","int","float","bool","bytes","bytearray","complex",
                "open","input","type","isinstance","issubclass","dir","vars","locals","globals","hasattr","getattr","setattr",
                "abs","all","any","eval","exec","format","help","iter","next","repr","slice","super"
            ];

            // IE 2026 09 23 / ODOO-341407: i18n: подсказки автодополнения
            const CUSTOM_WORDS = [
                { text: "process_model", signature: "process_model.params...", tooltip: this.t("The parameters of the current process model.")},
                { text: "workspace", signature: "workspace.params...", tooltip: this.t("The parameters of the current workspace.")},
                { text: "widget", signature: "widget.params...", tooltip: this.t("The parameters of the current widget.")},
                { text: "WIDGET", signature: "WIDGET.record...", tooltip: this.t("The current WIDGET object.")},
                { text: "record", signature: "record['field_name']", tooltip: this.t("The current record object.")},
                { text: "get_value", signature: "get_value(record, field, default=None)", tooltip: this.t("Get the value of a field from a record, with an optional default.")},
                { text: "set_value", signature: "set_value(record, field, value, add=False)", tooltip: this.t("Set the value of a field in a record, with an option to add if it doesn't exist.")},
            ];

            const cur = cm.getCursor();
            const token = cm.getTokenAt(cur);
            const from = { line: cur.line, ch: token.start };
            const to   = { line: cur.line, ch: cur.ch };

            const prefix = (token.string || "").toLowerCase();

            // 1) слова из документа
            const docWords = new Set();
            for (let i = 0; i < cm.lineCount(); i++) {
                cm.getLine(i).replace(/\b[\w]+\b/g, m => docWords.add(m));
            }

            // 2) нормализуем всё в единый массив объектов {text, ...}
            const normalize = (w) => (typeof w === "string" ? { text: w } : w);

            const dict = [
                ...[...docWords].map(w => ({ text: w })),
                ...PY_KEYWORDS.map(w => ({ text: w })),
                ...PY_BUILTINS.map(w => ({ text: w })),
                ...CUSTOM_WORDS.map(normalize),
            ];

            // 3) убираем дубли по text
            const byText = new Map();
            for (const item of dict) {
                if (item?.text) byText.set(item.text, item);
            }

            // 4) формируем list для CodeMirror
            const list = [...byText.values()]
                .filter(it => it.text.toLowerCase().startsWith(prefix) && it.text !== token.string)
                .sort((a,b) => a.text.localeCompare(b.text))
                .map(it => ({
                text: it.text,
                displayText: it.signature ? `${it.text} — ${it.signature}` : it.text,

                // ✅ самый простой tooltip
                title: it.tooltip || it.signature || "",

                // ✅ красивый вывод (опционально)
                render: it.tooltip || it.signature ? (el) => {
                    el.innerHTML = `
                    <div class="hint-item">
                        <div class="hint-title">${escapeHtml(it.text)}</div>
                        ${it.signature ? `<div class="hint-signature">${escapeHtml(it.signature)}</div>` : ""}
                        ${it.tooltip ? `<div class="hint-tooltip">${escapeHtml(it.tooltip)}</div>` : ""}
                    </div>
                    `;
                } : undefined,
                }));

            return { list, from, to };

            function escapeHtml(s) {
                return String(s).replace(/[&<>"']/g, c => ({
                "&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"
                }[c]));
            }
        },
        async serverHint(cm) { // TODO
            const cur = cm.getCursor();
            const text = cm.getValue();
            const body = {
                code: text,
                line: cur.line,
                ch: cur.ch
            };
            // debounce на 150–250 мс добавьте снаружи
            const res = await fetch("/api/py/complete", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body)
            }).then(r => r.json()).catch(() => ({ completions: [] }));

            // ожидаем [{label: "dict", insertText: "dict"}...]
            const token = cm.getTokenAt(cur);
            const from = { line: cur.line, ch: token.start };
            const to   = { line: cur.line, ch: token.end };

            return {
                list: res.completions?.map(c => c.insertText || c.label) || [],
                from, to
            };
        },

        isLineFolded(editor, line) {
            let info = editor.lineInfo(line);
            return info.gutterMarkers && info.gutterMarkers["CodeMirror-foldgutter"];
        },
        attr_set(editor) {
            // ✅ если апдейт пришел от родителя — не эмитим обратно
            if (this._fromParent) return;
            if (this._i18nReread) return   // IE 2026 10 06 / ODOO-341407: редактор перечитан после правки поля перевода (i18nCompanion_changed) — это не правка

            if (this.attr?.dropdown) {
                // // ✅ эмитим наверх (Dropdown.value изменится реактивно)
                // this.$emit("update:modelValue", this.local);

                if (this.attr.dropdown.value !== this.content_str) {
                    this.attr.dropdown.value = this.content_str
                    this.attr.dropdown.onInput_value()
                }
            } else {
                // IE 2026 10 06 / ODOO-341407 (решение Игоря В3, DESIGN §3.3, выключатель fe.i18n.formEditTranslation): под uk / ru правка translate-поля
                // пишет только перевод текущего языка (meta.comment → meta.comment_uk), английская база не трогается — раньше украинский текст Comment
                // «Інфо» ложился в базу (R2 §6). Текст, равный показанному (перечитывание из записи), — не правка: перевод не создаётся
                const tr = i18n_formEditTarget(this.store, this.WIDGET, this.attr, this.content_str)
                if (tr) {
                    if (tr.changed) {
                        this.store.attr_set(this.WIDGET, { ...this.attr, binding: tr.binding, translate: false }, this.content_str)
                        if (tr.full) this.store.i18n_autoUnmark(tr.record, tr.full)   // словарный meta.title_<L> стал ручным (IE 2026 10 06 / ODOO-341407: путь от записи-владельца — и у строки списка под карточкой Alt+F2)
                    }
                } else {
                    this.store.attr_set(this.WIDGET, this.attr, this.content_str)
                }
                this.check_attrTab()
                this.set_AttrTabPanel_countItems()
            }
        },
        // ---- IE 2026 10 06 / ODOO-341407 (заказ Игоря п.2, DESIGN §3.3): поля переводов под отдельным translate-полем (опция «Show translation fields») ----
        i18nCompanion_id(V) {
            return (this.attr?.html_id || this.attr?.id || 'strmulti') + '-i18n-' + (V._i18nOf?.lang || '')
        },
        // значение — по пути перевода (store.attr_get дописывает путь записи-владельца у формы строки); реактивно: правка основного поля под uk,
        // карточка Translations — поле перерисуется
        i18nCompanion_value(V) {
            const v = this.store.attr_get(this.WIDGET, V)
            return v === null || v === undefined ? '' : String(v)
        },
        // правка — как правка строки формы: store.attr_set → set_value ставит _meta.modified (Save в шапке); пишем на каждый ввод, как и основной редактор
        i18nCompanion_input(V, ev) {
            if (V.isReadOnly || V._i18nOf?.en) return
            this.store.attr_set(this.WIDGET, V, String(ev?.target?.value ?? ''))
            if (V._i18nOf?.auto) { const link = this.store.i18n_linkBinding(this.WIDGET, V.binding); this.store.i18n_autoUnmark(link.record, link.binding) }   // словарный перевод стал ручным (IE 2026 10 06 / ODOO-341407: полный путь поля перевода — пометка строки-записи под карточкой Alt+F2)
        },
        // правка завершена: под языком поля основной редактор показывает этот перевод — перечитать его (без записи обратно: _i18nReread)
        i18nCompanion_changed(V) {
            if (!this.attr || V._i18nOf?.lang !== this.store.get_lang()) return
            const v = this.store.attr_get(this.WIDGET, this.attr) || ''
            if (this.content_str === v) return
            this._i18nReread = true
            this.content_str = v
            if (this.editor) this.editor.setValue(String(v))
            this.$nextTick(() => { this._i18nReread = false })
        },
        _hide_empty() {
            return this.attr_nonEmptyWidget?.active && !this.attr_nonEmptyWidget?.hide && !this.attr.showEmpty
        },
        check_attrTab() {
            // родитель: при tabs_noId — структурно от рендерящей вкладки (parentAttr);
            // иначе parent_attr мог устареть после пересборки view — резолвим заново
            // (кроме initialAttr-копий: их attr_id указывает на чужой оригинал)
            if (this.store.tabs_noId && this.parentAttr) {
                this.parent_attr = this.parentAttr
            } else if (!this.initialAttr && this.attr_id != null) {
                const found = this.store.widget_attr(this.WIDGET, this.attr_id)
                if (found) { this.parent_attr = found.parent }
            }
            const parent_attr = this.parent_attr
            if (!parent_attr || (parent_attr.attr_type !== 'AttrTab' && parent_attr.attr_type !== 'AttrTabRow')) {
                return // hide управляет только видимостью вкладок
            }
            parent_attr._hideChecked = true   // IE 2026 09 06 / ODOO-336330: вердикт по факту — предварительная проверка панели (tabsPrecheck) его не трогает
            if (parent_attr.showEmpty) return
            const isEmpty = !this.content_str || !this.content_str.trim()
            if (parent_attr.attrs?.length === 1) {
                if (isEmpty && this._hide_empty()) {
                    parent_attr.hide = true
                    this.count_empty_tab = 1
                } else {
                    parent_attr.hide = false
                    this.count_empty_tab = 0
                }
            } else if (parent_attr.hide) {
                // вкладка больше не одиночная — прятать её некому, снимаем залипший hide
                parent_attr.hide = false
                this.count_empty_tab = 0
            }
        },
        set_AttrTabPanel_countItems() {
            if (this.set_AttrTabPanel_countItems_timerId) { clearTimeout(this.set_AttrTabPanel_countItems_timerId) }
            this.set_AttrTabPanel_countItems_timerId = window.$cg.setTimeout(this, "AttrStrMulti.set_AttrTabPanel_countItems", () => {
                this.set_AttrTabPanel_countItems_afterTimeout()
                this.set_AttrTabPanel_countItems_timerId = null
            }, 100)
        },
        set_AttrTabPanel_countItems_afterTimeout() {
            if (this.attr?.['can-set_AttrTabPanel_countItems']) {
                let countItems = 0
                if (this.content_str && this.content_str.trim()) {
                    countItems = this.content_str.split('\n').filter(line => line.trim()).length
                }
                if (this.parent_attr.countItems !== countItems) {
                    this.parent_attr.countItems = countItems
                }
            }
        },
        onChipsUpdate(chips) {
            this.chips_list = chips
            this.apply_CHIPS()
        },
        apply_CHIPS(e=null, {check_nonEmptyWidget=true}={}) {
            this.check_attrTab()
            if (check_nonEmptyWidget) {
                this.store.check_nonEmptyWidget(this.WIDGET)
            }
            if (!this.editor) return
            const searchChips = this.chips_list.filter(c => c.use !== false && c.segment === 'CHIP-Search')
            this._applyChipsOverlay(searchChips)
            const cm = this.editor
            const cursor = cm.getCursor('from')
            cm.operation(() => {
                for (let i = 0; i < cm.lineCount(); i++) {
                    cm.removeLineClass(i, 'wrap', 'cm-line-filtered-out')
                }
                if (!searchChips.length) return
                // ч.2: чекбокс «показать строки без найденных» — оставляем подсветку
                // (overlay уже применён выше), но НЕ скрываем строки без совпадений
                if (searchChips.some(c => c.showAllLines)) return
                for (let i = 0; i < cm.lineCount(); i++) {
                    const lineText = cm.getLine(i).toLowerCase()
                    const matches = searchChips.some(chip => lineText.includes(chip.title.toLowerCase()))
                    if (!matches) {
                        cm.addLineClass(i, 'wrap', 'cm-line-filtered-out')
                    }
                }
            })
            if (searchChips.length) {
                this._scrollToChipMatch(cm, cursor.line, searchChips)
            } else {
                // фильтр снят (удалён последний search-чипс): вернуть выделенную строку
                // в видимую область — после разворота скрытых строк она могла уехать
                // за viewport (задача 14)
                requestAnimationFrame(() => cm.scrollIntoView({ line: cursor.line, ch: cursor.ch || 0 }))
            }
            this._recomputeSearchNav(cm, searchChips)
        },
        _recomputeSearchNav(cm, searchChips) {
            // задача 14 ч.1: собрать все позиции совпадений (объединение терминов,
            // регистронезависимо; eval-выражения '=' не ищем позиционно), проставить
            // счётчик matchCount/matchIndex на search-чипсы (их читает AttrChips)
            const list = []
            for (const chip of searchChips) {
                const term = String(chip.title || '')
                if (!term || term.startsWith('=')) continue
                const cur = cm.getSearchCursor(term, { line: 0, ch: 0 }, { caseFold: true })
                while (cur.findNext()) list.push({ from: cur.from(), to: cur.to() })
            }
            list.sort((a, b) => a.from.line - b.from.line || a.from.ch - b.from.ch)
            const idx = Math.min(this._searchNav?.index || 0, Math.max(0, list.length - 1))
            this._searchNav = { list, index: idx }
            for (const chip of searchChips) { chip.matchCount = list.length; chip.matchIndex = list.length ? idx : 0 }
            this.$refs.chips?.$forceUpdate()
        },
        onChipSearchNav({ dir }) {
            const nav = this._searchNav
            if (!nav || !nav.list.length) return
            nav.index = (nav.index + dir + nav.list.length) % nav.list.length
            const m = nav.list[nav.index]
            const cm = this.editor
            cm.setSelection(m.from, m.to)
            cm.scrollIntoView({ from: m.from, to: m.to }, 60)
            cm.focus()
            const searchChips = this.chips_list.filter(c => c.use !== false && c.segment === 'CHIP-Search')
            for (const chip of searchChips) chip.matchIndex = nav.index
            this.$refs.chips?.$forceUpdate()
        },
        _scrollToChipMatch(cm, fromLine, searchChips) {
            const lineMatches = (i) => {
                const text = cm.getLine(i)?.toLowerCase() || ''
                return searchChips.some(c => text.includes(c.title.toLowerCase()))
            }
            let target = fromLine
            if (!lineMatches(target)) {
                let found = false
                for (let i = fromLine - 1; i >= 0 && !found; i--) {
                    if (lineMatches(i)) { target = i; found = true }
                }
                if (!found) {
                    for (let i = fromLine + 1; i < cm.lineCount(); i++) {
                        if (lineMatches(i)) { target = i; break }
                    }
                }
            }
            requestAnimationFrame(() => cm.scrollIntoView({ line: target, ch: 0 }))
        },
        _applyChipsOverlay(searchChips) {
            const cm = this.editor
            if (this._chipsOverlay) {
                cm.removeOverlay(this._chipsOverlay)
                this._chipsOverlay = null
            }
            if (!searchChips.length) return
            const terms = searchChips.map(c => c.title.toLowerCase())
            this._chipsOverlay = {
                token(stream) {
                    for (const term of terms) {
                        if (stream.match(term, true, true)) return 'chip-search-match'
                    }
                    stream.next()
                    return null
                }
            }
            cm.addOverlay(this._chipsOverlay)
        },
        parenFold(cm, start) {
            const line = cm.getLine(start.line)
            const trimmed = line.trimEnd()
            const parenIdx = trimmed.lastIndexOf('(')
            if (parenIdx === -1) return
            if (trimmed.slice(parenIdx + 1).trim()) return

            let depth = 1
            for (let i = start.line + 1; i < cm.lineCount(); i++) {
                const text = cm.getLine(i)
                for (let j = 0; j < text.length; j++) {
                    if (text[j] === '(') depth++
                    if (text[j] === ')') depth--
                    if (depth === 0) {
                        return {
                            from: CodeMirror.Pos(start.line, trimmed.length),
                            to:   CodeMirror.Pos(i, j)
                        }
                    }
                }
            }
        },
        attrResize() {
            if (this.attrResize_timeout) { clearTimeout(this.attrResize_timeout) }
            this.attrResize_timeout = window.$cg.setTimeout(this, "AttrStrMulti.attrResize", () => {
                this.attrResize_afterTimeout()
                this.attrResize_timeout = null
            }, 1)
        },
        attrResize_afterTimeout() {
            if (!this.editor) return
            if (this.attr?.noAutoResize) return
            const elementForm = document.getElementById(`WIDGET${this.widget_id}`)
            if (!elementForm) return
            const wrapperEl = this.editor.getWrapperElement()
            const wrapperRect = wrapperEl.getBoundingClientRect()
            if (wrapperRect.height <= 10) return
            const widgetAttrsEl = null // elementForm.querySelector('.widget-attrs')
            const containerRect = (widgetAttrsEl || elementForm).getBoundingClientRect()
            const i18nH = this.$refs.i18nCompanions?.offsetHeight || 0   // IE 2026 10 06 / ODOO-341407: поля переводов под редактором — редактор не выталкивает их за низ формы
            let newHeight = Math.floor(containerRect.bottom - wrapperRect.top - 3 - i18nH)
            if (newHeight > containerRect.height) newHeight = 300
            if (newHeight < 80) newHeight = 80
            if (wrapperEl.style.height !== `${newHeight}px`) {
                this.editor.setSize(null, newHeight)
            }
        },
        editorReady(editor) {
            this.editor = editor
            this.attrResize()

            editor.setOption('foldOptions', {
                rangeFinder: CodeMirror.fold.combine(
                    CodeMirror.fold.brace,
                    CodeMirror.fold.indent,
                    CodeMirror.fold.comment,
                    this.parenFold
                ),
                widget: (from, to) => {
                    const count = to.line - from.line
                    const el = document.createElement('span')
                    el.className = 'CodeMirror-foldmarker-1 m-2 pr-1'
                    el.innerHTML = ` ··· ${this.t('{n} ln', { n: count })} <i class="pi dropdown-chevron pi-chevron-down"></i>`   // IE 2026 09 23 / ODOO-341407: i18n
                    el.addEventListener('mousemove', e => e.stopPropagation())
                    return el
                }
            })

            editor.addKeyMap({
                // комментарии
                "Ctrl-/": (cm) => this.toggleLineComment(cm),
                "Cmd-/":  (cm) => this.toggleLineComment(cm),

                // перемещение строк
                "Alt-Up":   cm => this.moveLines(cm, -1),
                "Alt-Down": cm => this.moveLines(cm, 1),

                // ✅ дублирование строк
                "Shift-Alt-Up":   cm => this.duplicateLines(cm, -1),
                "Shift-Alt-Down": cm => this.duplicateLines(cm,  1),

                "Esc": (cm) => {
                    cm.getInputField().blur()
                    this.store.runActionForHotKey(this.WIDGET, "Esc")
                },
            });
  
            const isWordChar = ch => /[\w.]/.test(ch); // буквы/цифры/нижнее подчёркивание/точка

            editor.on("inputRead", (cm, change) => {
                if (change.text && change.text.length === 1 && isWordChar(change.text[0])) {
                    CodeMirror.commands.autocomplete(cm, null, { completeSingle: false });
                }
            });
        },
        normalizeLineRange(cm) {
            const doc = cm.getDoc();
            let from = doc.getCursor("from");
            let to   = doc.getCursor("to");

            // если выделение заканчивается ровно в начале строки —
            // считаем, что эта строка НЕ входит в выделение
            if (to.ch === 0 && to.line > from.line) {
                to = { line: to.line - 1, ch: cm.getLine(to.line - 1).length };
            }

            // если курсор без выделения — работаем по текущей строке
            if (from.line === to.line && from.ch === to.ch) {
                from = { line: from.line, ch: 0 };
                to   = { line: from.line, ch: cm.getLine(from.line).length };
            }

            return { from, to };
        },
        duplicateLines(cm, direction) {
            const doc = cm.getDoc();
            const { from, to } = this.normalizeLineRange(cm);

            const lines = [];
            for (let i = from.line; i <= to.line; i++) {
                lines.push(doc.getLine(i));
            }
            const block = lines.join("\n") + "\n";

            const insertLine = direction < 0 ? from.line : to.line + 1;
            doc.replaceRange(block, { line: insertLine, ch: 0 });

            // опционально: выделить продублированный блок
            const start = insertLine;
            const end = insertLine + lines.length - 1;
            doc.setSelection({ line: start, ch: 0 }, { line: end, ch: doc.getLine(end).length });
        },
        focus() {
            // CodeMirror instance у тебя лежит в this.editor
            if (this.editor) {
                this.editor.focus();

                // если хочешь курсор в конец:
                const doc = this.editor.getDoc();
                const last = doc.lastLine();
                doc.setCursor(last, doc.getLine(last).length);
            }
        },
        handleVisibility(isVisible) {
            const vueObj = this
            if (vueObj.isVisible === isVisible) {
                return
            }
            vueObj.isVisible = isVisible
            if (isVisible && this.editor) {
                if (this.need_content_Changed_afterTimeout) {
                    this.content_Changed_afterTimeout()
                } else {
                    this.editor.refresh()
                }
                this.attrResize()
            }
        },
        handleKeydown(e) {
            if (e.key === 'Enter' && !e.shiftKey && this.attr.afterEnter) {
                // e.preventDefault()
                this.store.executeStoreMethod(this.WIDGET.vueObj, this.attr.afterEnter)
                this.content_str = String(this.content_str || '').trim()
            }
        },

        getLineCommentPrefix(cm) {
            // можно точнее, но для твоих режимов достаточно:
            const mode = (cm.getOption("mode") || "").toString();

            // SQL / PostgreSQL
            if (mode.includes("sql") || mode.includes("pgsql")) return "-- ";

            // Python
            if (mode.includes("python")) return "# ";

            // JS (если нужно)
            if (mode.includes("javascript")) return "// ";

            // fallback
            return "-- ";
        },

        toggleLineComment(cm) {
            const prefix = this.getLineCommentPrefix(cm);

            cm.operation(() => {
            const doc = cm.getDoc();
            let from = doc.getCursor("from");
            let to = doc.getCursor("to");

            // если нет выделения — работаем по текущей строке
            if (from.line === to.line && from.ch === to.ch) {
                from = { line: from.line, ch: 0 };
                to = { line: from.line, ch: cm.getLine(from.line).length };
            }

            const startLine = Math.min(from.line, to.line);
            const endLine = Math.max(from.line, to.line);

            // Определяем: будем комментировать или раскомментировать?
            // Если ВСЕ непустые строки уже с prefix -> раскомментируем, иначе закомментируем
            let allCommented = true;

            for (let i = startLine; i <= endLine; i++) {
                const line = cm.getLine(i);
                if (!line.trim()) continue; // пустые строки игнорим
                const indent = line.match(/^\s*/)?.[0] || "";
                if (!line.startsWith(indent + prefix)) {
                allCommented = false;
                break;
                }
            }

            for (let i = startLine; i <= endLine; i++) {
                const line = cm.getLine(i);
                const indent = line.match(/^\s*/)?.[0] || "";

                if (!line.trim()) continue;

                if (allCommented) {
                // remove prefix после indent
                const expected = indent + prefix;
                if (line.startsWith(expected)) {
                    cm.replaceRange(
                    "",
                    { line: i, ch: expected.length - prefix.length }, // аккуратно: после indent
                    { line: i, ch: expected.length }
                    );
                }
                } else {
                // add prefix после indent
                cm.replaceRange(prefix, { line: i, ch: indent.length });
                }
            }
            });
        },

        moveLines(cm, direction) {
            const doc = cm.getDoc();
            const selections = doc.listSelections();

            cm.operation(() => {
            selections.forEach(sel => {
                let from = Math.min(sel.anchor.line, sel.head.line);
                let to   = Math.max(sel.anchor.line, sel.head.line);

                // если курсор без выделения
                if (sel.anchor.line === sel.head.line) {
                from = to = sel.anchor.line;
                }

                if (direction === -1 && from === 0) return;
                if (direction === 1 && to === cm.lineCount() - 1) return;

                const lines = [];
                for (let i = from; i <= to; i++) {
                lines.push(doc.getLine(i));
                }

                // удаляем блок
                doc.replaceRange(
                "",
                { line: from, ch: 0 },
                { line: to + 1, ch: 0 }
                );

                const insertAt = direction === -1 ? from - 1 : from + 1;

                // вставляем
                doc.replaceRange(
                lines.join("\n") + "\n",
                { line: insertAt, ch: 0 }
                );

                // восстанавливаем выделение
                doc.setSelection(
                { line: insertAt, ch: 0 },
                { line: insertAt + lines.length - 1, ch: doc.getLine(insertAt + lines.length - 1).length }
                );
            });
            });
        },

    },
    computed: {
        commandPanelOverflow() {
            if (this.commandPanelMaxVisible >= this.commandPanel.length) return []
            return this.commandPanel
                .slice(this.commandPanelMaxVisible)
                .filter(item => item.attr_type !== 'AttrSeparator' && item.visible !== false)
        },
        // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.2, DESIGN §3.3): поля переводов под полем — узлы formRowsFor; пересчёт — по опции виджета (реактивная
        // карта стора), языку интерфейса, списку языков базы, подписи поля и смене узла (i18nEpoch). Выпадающий редактор (initialAttr) — без полей
        i18nCompanions() {
            void this.i18nEpoch
            if (this.initialAttr || !this.attr) return []
            return i18n_companionRowsFor(this.store, this.WIDGET, this.attr, { existing: i18n_bindingsOf(this.parent_attr?.attrs) })
        },
    },
    components: {
      Codemirror,
    },

    watch: {
        // IE 2026 10 06 / ODOO-341407: поля переводов появились / исчезли — высота редактора пересчитывается (attrResize оставляет им место)
        i18nCompanions(list, prev) {
            if ((list?.length || 0) !== (prev?.length || 0)) this.$nextTick(() => this.attrResize())
        },
        // ✅ родитель поменял value → обновляем редактор
        modelValue: {
            immediate: true,
            handler(v) {
                const next = v ?? "";
                if (next === this.content_str) return;

                this._fromParent = true;
                this.content_str = next;

                // если редактор уже инициализирован — аккуратно обновим его значение
                this.$nextTick(() => {
                    this._fromParent = false;
                });
            },
        },
    },

    
}
</script>

<style>
.attr-codemirrort {
    width:-webkit-fill-available !important;
}
.CodeMirror pre.CodeMirror-line, .CodeMirror pre.CodeMirror-line-like {
    font-family: monospace;
    /*font-family: Consolas, 'Courier New', monospace;*/
}
.CodeMirror-hints {
    z-index: 99999;
}
.CodeMirror-hint .hint-title { font-weight: 700; }
.CodeMirror-hint .hint-signature  { font-size: 11px; opacity: .75; }
.CodeMirror-hint .hint-tooltip   { font-size: 11px; opacity: .8; margin-top: 2px; }

.strmulti-fold-buttons {
    flex-shrink: 0;
    position: sticky;
    top: 0;
    z-index: 10;
    background: white;
}
.CodeMirror-foldmarker-1 {
    font-stretch: ultra-condensed;
    color: white;
    font-family: arial;
    background: #8ea0ff;
    border-radius: 3px;
    cursor: pointer !important;
}
.cm-line-filtered-out {
    display: none;
}
.cm-chip-search-match {
    background-color: rgba(255, 210, 0, 0.45);
    border-radius: 2px;
}
/* IE 2026 10 06 / ODOO-341407 (заказ Игоря п.2): поля переводов под отдельным translate-полем (опция «Show translation fields»);
   словарный перевод (не сохранён в записи) — серым курсивом, как .i18n-auto карточки Translations; «(en)» — только чтение */
.i18n-companions { display: flex; flex-direction: column; gap: 4px; margin-top: 6px; }
.i18n-companion-row { display: flex; flex-direction: column; }
.i18n-companion-row .label-sheet { margin-bottom: 2px; }
textarea.i18n-companion { box-sizing: border-box; width: 100%; min-height: 3.2em; resize: vertical; font: inherit; font-size: 0.875rem; padding: 4px 6px;
    border: 1px solid var(--surface-border, #dee2e6); border-radius: 4px; background: var(--surface-card, #fff); color: var(--text-color, inherit); }
textarea.i18n-companion[readonly] { background: var(--surface-ground, #f8f9fa); }
.i18n-companion-row.i18n-auto textarea.i18n-companion { color: #8a8f98; font-style: italic; }
</style>